import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  BRANCH_LOCATIONS_GET_FAILURE: 'BRANCH_LOCATIONS_GET_FAILURE',
  BRANCH_LOCATIONS_GET_REQUEST: 'BRANCH_LOCATIONS_GET_REQUEST',
  BRANCH_LOCATIONS_GET_SUCCESS: 'BRANCH_LOCATIONS_GET_SUCCESS',
};

export const actionCreators = {
  getRequest: () => ({
    type: actionTypes.BRANCH_LOCATIONS_GET_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.BRANCH_LOCATIONS_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.BRANCH_LOCATIONS_GET_FAILURE,
  }),
  getSuccess: (branchLocations: Array<any>) => ({
    type: actionTypes.BRANCH_LOCATIONS_GET_SUCCESS,
    payload: { branchLocations },
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.BRANCH_LOCATIONS_GET_FAILURE,
    error,
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
